<script>
import {mapState} from 'vuex'

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    data() {
        return {
            form: this.mindsetAssessment,
            goalSums: null,
        }
    },

    props: ['mindsetAssessment', 'goalSumsUrl', 'lifeStories', 'moodWarning'],

    mixins: [],

    computed: {
    },

    created() {
    },

    mounted() {
        this.getGoalSums();

        if(this.moodWarning) {
            setTimeout(function () {
                $('#moodWarningFormModal').modal('show');
            }, 500);
        }
    },

    watch: {
    },

    methods: {
        getGoalSums() {
            axios
                .get(this.goalSumsUrl)
                .then(response => {
                    this.goalSums = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        storySum(current, aspirational) {
            if (current && aspirational) {
                return  parseInt(aspirational) - parseInt(current);
            }
            return 0;
        },
        storyTotal(current, aspirational) {
            var sum = this.storySum(current, aspirational);
            if (sum == 0) {
                return;
            }
            if (sum > 0) {
                return '+ ' + sum;
            }

            if (sum < 0) {
                return '- ' + Math.abs(sum);
            }
        },
        storyClass(current, aspirational) {
            var sum = this.storySum(current, aspirational);
            if (sum == 0) {
                return;
            }
            if (sum > 0) {
                return 'positive';
            }

            if (sum < 0) {
                return 'negative';
            }
        },

        launchModal() {
            $('#mindsetAssessmentFormModal').modal('show');
        },
    },

    components: {
        VueSlider
    }
}
</script>
